// extracted by mini-css-extract-plugin
export default {"textareaWrapper":"textarea_textareaWrapper__TFMmb","textarea":"textarea_textarea__yGgWQ","length":"textarea_length__qd2XC","buttonDelete":"textarea_buttonDelete__MKslK"};